import type { CodemodOrder } from '@design-system/migration-utils';

import {
  migrateMeterbarSlotShowIndicatorMotion,
  migrateMeterbarSlotShowIndicatorCodemod,
} from './codemods/migrate-meterbar-slot-show-indicator.js';
import {
  migrateMeterbarThresholdShowIndicatorMotion,
  migrateMeterbarThresholdShowIndicatorCodemod,
} from './codemods/migrate-meterbar-threshold-show-indicator.js';

export const codemodOrder: CodemodOrder = [
  {
    description:
      'migrate deprecated meterbar per-threshold showIndicator to showThresholdIndicators',
    motion: migrateMeterbarThresholdShowIndicatorMotion,
    codemod: migrateMeterbarThresholdShowIndicatorCodemod,
  },
  {
    description:
      'migrate deprecated MeterBarChart.ThresholdIndicator showIndicator slot prop to showThresholdIndicators',
    motion: migrateMeterbarSlotShowIndicatorMotion,
    codemod: migrateMeterbarSlotShowIndicatorCodemod,
  },
];
